module.exports = __webpack_public_path__ + "static/acceleratedfinancial-03988b5036d6021af0dcfe4c5432d745.jpg";